import FlightInfoCardContentDesktop from "./FlightInfoCardContent.desktop";

export default FlightInfoCardContentDesktop;
